import { refangDomain, toPunycode } from './domainUtils';

// The lookup endpoint accepts 1-100 domains per request (ENG-925); the bulk
// page runs a single request, so this is also the per-run cap.
export const MAX_LOOKUP_DOMAINS = 100;

const DOMAIN_SHAPE = /^([a-z0-9-]+\.)+(xn--[a-z0-9-]+|[a-z]{2,})$/i;

export interface ParsedDomainList {
  domains: string[];
  invalid: string[];
}

/**
 * Splits pasted text (commas, new lines, spaces, semicolons) into a clean,
 * deduplicated domain list. Each token is refanged and reduced to its host,
 * so "hxxps://evil[.]com/login" becomes "evil.com". Tokens that don't look
 * like a domain are returned in `invalid` instead of being sent to the API.
 * Unicode (IDN) domains are converted to punycode, the form threats are
 * stored under.
 */
export const parseDomainList = (text: string): ParsedDomainList => {
  const domains: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();
  text
    .split(/[\s,;]+/)
    .filter(Boolean)
    .forEach(token => {
      const domain = toPunycode(
        refangDomain(token).toLowerCase().replace(/\.$/, ''),
      );
      if (!DOMAIN_SHAPE.test(domain)) {
        if (!invalid.includes(token)) invalid.push(token);
        return;
      }
      if (seen.has(domain)) return;
      seen.add(domain);
      domains.push(domain);
    });
  return { domains, invalid };
};
